import { apiClient } from "../apiClient";
import { TaskId } from "../../shared-types";
import { useMutation } from "react-query";

const forceCompleteTask = (data: TaskId): Promise<string> =>
  apiClient.post("/task/forceComplete", data).then((resp) => resp.data);

export const useForceCompleteTask = (
  onSuccess?: (data: string) => void,
  onError?: () => void,
) => {
  const { isLoading, mutate } = useMutation(forceCompleteTask, {
    onSuccess,
    onError,
  });

  return {
    isLoading,
    mutate,
  };
};
